import { faTableCellsRowUnlock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Gate } from "../../../models/Gate";
import { MapObject } from "../../../models/MapObject";
import DamnMappableAttachments from "../damnMappableAttachments";
import AreaAvatar from "../../Map/AreaAvatar";

interface GateSectionProps {
    gate: Gate | null;
    gateMapObject: MapObject | null;
}

const GateSection: React.FC<GateSectionProps> = ({ gate, gateMapObject }) => {
    if (!gate || !gateMapObject) {
        return null;
    }

    return (
        <div className="p-4 bg-linear-to-r from-plot-green/5 to-plot-green/10 rounded-lg mx-4">
            <div className="flex flex-col xl:flex-row flex-1 w-full justify-between gap-2">
                <div className="flex flex-row items-center gap-3 px-4 py-3">
                    <FontAwesomeIcon icon={faTableCellsRowUnlock} className="text-green-500 shrink-0" size="lg" />
                    <div className="flex-1 w-full">
                        <p className="text-xs text-gray-600 font-medium">Enter at Gate:</p>
                        <div className="flex flex-row items-center text-base font-bold text-gray-900">
                            <AreaAvatar mappable={gate} mapObject={gateMapObject} />
                            {gate?.name}
                        </div>
                    </div>
                </div>
                <DamnMappableAttachments mappable={gate} />
            </div>
        </div>
    );
};

export default GateSection;
